'use client';

import { useState, useCallback } from 'react';
import { useApiStore } from '@/context/global/stores/apiStore';

export const useSetSongFollow = () => {
  const { API } = useApiStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setSongFollow = useCallback(
    async (songId: number, like: boolean): Promise<boolean> => {
      setLoading(true);
      setError(null);

      try {
        await API.Song.PostSetSongFollow(songId, like);
        return true;
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : 'Failed to update song follow status';
        setError(errorMessage);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [API],
  );

  return {
    setSongFollow,
    loading,
    error,
  };
};
